import React from 'react';
import { getCurrentLanguage } from './voiceUtils';

export function TimeSelector({ value, onChange, className = "", dataTestId = "time-selector" }) {
  const currentLanguage = getCurrentLanguage();

  const parseTime = (timeStr) => {
    if (!timeStr) {
      const now = new Date();
      return { hour: now.getHours(), minute: now.getMinutes() };
    }
    const [h, m] = timeStr.split(':').map(Number);
    return { hour: h || 0, minute: m || 0 };
  };

  const { hour, minute } = parseTime(value);

  const updateTime = (newHour, newMinute) => {
    const timeStr = `${String(newHour).padStart(2, '0')}:${String(newMinute).padStart(2, '0')}`;
    onChange(timeStr);
  };

  const hours = Array.from({ length: 24 }, (_, i) => i);
  const minutes = Array.from({ length: 60 }, (_, i) => i);

  const getTimeDescription = (h) => {
    if (h >= 0 && h < 6) return currentLanguage === 'es' ? 'Noche' : 'Night';
    if (h >= 6 && h < 12) return currentLanguage === 'es' ? 'Mañana' : 'Morning';
    if (h >= 12 && h < 18) return currentLanguage === 'es' ? 'Tarde' : 'Afternoon';
    return currentLanguage === 'es' ? 'Noche' : 'Evening';
  };

  return (
    <div className={`space-y-2 ${className}`} data-testid={dataTestId}>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-xs text-vault-text-secondary block mb-1 text-center">
            {currentLanguage === 'es' ? 'Hora (0-23)' : 'Hour (0-23)'}
          </label>
          <select
            value={hour}
            onChange={(e) => updateTime(Number(e.target.value), minute)}
            className="w-full vault-input h-14 text-xl text-center font-bold bg-vault-surface border-vault-border cursor-pointer"
            data-testid={`${dataTestId}-hour`}
          >
            {hours.map((h) => (
              <option key={h} value={h}>{String(h).padStart(2, '0')}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-xs text-vault-text-secondary block mb-1 text-center">
            {currentLanguage === 'es' ? 'Minutos' : 'Minutes'}
          </label>
          <select
            value={minute}
            onChange={(e) => updateTime(hour, Number(e.target.value))}
            className="w-full vault-input h-14 text-xl text-center font-bold bg-vault-surface border-vault-border cursor-pointer"
            data-testid={`${dataTestId}-minute`}
          >
            {minutes.map((m) => (
              <option key={m} value={m}>{String(m).padStart(2, '0')}</option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="bg-vault-surface border-2 border-vault-gold rounded-lg p-3">
        <div className="text-center">
          <span className="text-vault-gold font-mono text-3xl font-bold">
            {String(hour).padStart(2, '0')}:{String(minute).padStart(2, '0')}
          </span>
          <span className="text-vault-text ml-3 text-lg">
            ({getTimeDescription(hour)})
          </span>
        </div>
        <div className="mt-2 pt-2 border-t border-vault-border grid grid-cols-4 gap-1 text-xs text-center">
          <div className="text-vault-text-secondary">
            <span className="text-vault-gold font-bold">06</span> = 6 AM
          </div>
          <div className="text-vault-text-secondary">
            <span className="text-vault-gold font-bold">12</span> = 12 PM
          </div>
          <div className="text-vault-text-secondary">
            <span className="text-vault-gold font-bold">18</span> = 6 PM
          </div>
          <div className="text-vault-text-secondary">
            <span className="text-vault-gold font-bold">00</span> = 12 AM
          </div>
        </div>
      </div>
    </div>
  );
}
